module.exports = __webpack_public_path__ + "img/77398.a4a78b33.svg";